
import React from 'react';

//redux
//import {createStore} from 'redux';
//import PropTypes from 'prop-types';

//import { Link } from 'react-router-dom'

//ejemplo

//import ejemplo from './Ejemplo';

//booststrap
import { Form, FormGroup, Button, Label, Input
} from 'reactstrap';

//css
import './AdquirirProductos.scss';

class AdquirirProducto extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formulario: false
    };
  }

  render() {
    return (
      <div className={`${this.state.formulario? 'formularioVis': 'formularioHidd'} formBack`}>
        <div className="IconClose" >
        </div>
        <div className={"FormCotizacion"}>
          <Form className={"Form-input"}>
            <h1 className={"Tittle-form"}>Formulario</h1>
            <FormGroup>
              <Label>Nombre</Label>
              <Input/>
            </FormGroup>
            <FormGroup>
              <Label>Correo Electronicoo</Label>
              <Input/>
            </FormGroup>
            <FormGroup>
              <Label>Telefono</Label>
              <Input/>
            </FormGroup>
            <FormGroup>
              <Label>Mensaje</Label>
              <Input type="textarea"/>
            </FormGroup>
            <Button className={"Btn-Sutmit"}>Enviar</Button>
          </Form>
        </div>
      </div>
    );
  }
}

 export default AdquirirProducto;



// WEBPACK FOOTER //
// ./src/Components/Cotizar/AdquirirProductos.jsx